<template>
  <div class="monitoringCardWrap">
    <div class="cardBox">
      <el-carousel indicator-position="outside" :autoplay="false">
        <el-carousel-item v-for="(item, index) in monitoringmList" :key="index">
          <ul>
            <li v-for="v in item" :key="v.name">
              <h5>{{ v.name }}({{ v.total }})</h5>
              <div class="txtBox">
                <p>{{ v.active }}</p>
                <p>{{ v.notActive }}</p>
                <p>{{ v.alarmNum }}</p>
              </div>
            </li>
          </ul>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  data() {
    return {
      monitoringmList: [],
    };
  },
  methods: {
    async getList() {
      let res = await api.controlGetMonitoring({
        assetId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
      });
      if (res && res.data.code == 200) {
        let data = res.data.data.deviceTypes.filter((v) => {
          return v.name !== "default";
        });
        let arr = [];
        for (let i = 0; i < data.length; i += 12) {
          arr.push(data.slice(i, i + 12));
        }
        this.monitoringmList = arr;
        let total = 0,
          alarmNum = 0,
          notActive = 0,
          active = 0;
        data.map((v) => {
          total += Number(v.total);
          alarmNum += Number(v.alarmNum);
          notActive += Number(v.notActive);
          active += Number(v.active);
        });
        this.$emit("getMonitoringData", {
          total,
          alarmNum,
          notActive,
          active,
        });
      }
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.monitoringCardWrap {
  width: 96%;
  height: 96%;
  margin: 2% auto;
  .cardBox {
    width: 100%;
    height: 100%;
    ul {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      justify-items: flex-start;
      overflow: auto;
      li {
        width: 23%;
        height: 80px;
        border-radius: 4px;
        border: 1px solid #e3e3e3;
        margin: 0 10px 15px 0;
        h5 {
          height: 32px;
          line-height: 32px;
          color: #20558c;
          font-size: 13px;
          background: #deeeff;
          text-align: center;
        }
        .txtBox {
          @include setFlexAround;
          height: 48px;
          p {
            font-weight: bold;
            font-size: 16px;
            color: #666;
          }
          p:nth-child(1) {
            color: #037cff;
          }
          p:nth-child(3) {
            color: #fa6400;
          }
        }
      }
    }
  }
}
</style>
